module.exports = __webpack_public_path__ + "static/banner-bg-372abad281153baed0c0070d99d6a207.jpg";